import Vue from "vue";

let fontSize = "regular";

const getFontSize = () => {
    const size = Vue.$localStorage.get("fontSize");
    if (size === "regular" || size === "medium" || size === "big") {
        fontSize = size;
    }
    return fontSize;
}

const changeFont = (size) => {
    if (size === "regular" || size === "medium" || size === "big") {
        Vue.$localStorage.set('fontSize', size);
        fontSize = size;
    }
    return fontSize;
}

export const fontSizeService = {
    getFontSize,
    changeFont
};
